<template>
  <v-alert v-show="duplicates.length" border="start" variant="outlined" type="warning">
    <div v-for="duplicate in duplicates" :key="`${duplicate.type}-${duplicate.id}`">
      <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
      <nuxt-link target="_blank" :to="{ query: { activeOrder: duplicate.id } }">Order</nuxt-link>
      with matching {{ duplicate.type }} reference found
    </div>
  </v-alert>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'

export interface Props {
  orderId: number,
  supplierId: number,
}
const props = defineProps<Props>()

const duplicates = ref<Order[]>([])

const { $api, $error } = useNuxtApp()
const checkForDuplicates = async (reference: any) => {
  if (reference) {
    try {
      const [quoteOrders, invoiceOrders] = await Promise.all([
        $api.v1.rfqs.list({
          supplier: props.supplierId,
          supplierReference: reference,
        }),
        $api.v1.rfqs.list({
          invoiceNumber: reference,
          supplier: props.supplierId,
        }),
      ])

      duplicates.value = quoteOrders.map((order: Order) => ({ id: order.id, type: 'supplier' }))
        .concat(invoiceOrders.map((order: Order) => ({ id: order.id, type: 'invoice' })))
        .filter(order => order.id !== props.orderId)
    }
    catch (error) {
      $error.report(error)
    }
  }
}
defineExpose({ checkForDuplicates })
</script>
